import React from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { FaSignOutAlt } from "react-icons/fa";
import { withRouter } from 'react-router-dom';

//Constantes auxiliares para sweetalerts:
let logoutConfirmationAlertContent = {
    title: 'Logout',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'info',
    html: '<p style="font-size: 0.75em; text-align: center">¿Estás seguro de cerrar la sesión activa?<br/><br/>Usuario activo: <b>@userEmail</b></p>',
    showCancelButton: true,
    confirmButtonText: 'Cerrar sesión',
    cancelButtonText: 'Cancelar',
    focusCancel: true
}

let LogoutButton = (props) => {
    return (
        <li className="nav-item">
            <button className="nav-link btn-magnify button-on-navbar"
                title="Cerrar sesión" data-tut="reactour__mainLayout.logoutButton"
                style={{ backgroundColor: "transparent", border: "none" }}
                onClick={() => {
                    let myLogoutConfirmationAlertContent = { ...logoutConfirmationAlertContent };
                    myLogoutConfirmationAlertContent.html = myLogoutConfirmationAlertContent.html.replace("@userEmail", props.activeUser.email);

                    Swal.fire(myLogoutConfirmationAlertContent)
                        .then(result => {
                            if (result.value) {
                                localStorage.clear();
                                props.logoutUser();
                                props.history.push('/auth/login');
                            }
                        });

                }} >
                <FaSignOutAlt style={{ height: 20, width: 20 }} />
                <p>
                    <span className="d-lg-none d-md-block" style={{ marginLeft: 5 }}>
                        Logout
                    </span>
                </p>
            </button>
        </li >
    );
}

const mapdispatchToProps = dispatch => {
    return {
        logoutUser: () => {
            dispatch({ type: "changeActiveUser", newActiveUser: {}, isUserLogged: false })
        }
    };
};

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        isUserLogged: state.mainReducer.isUserLogged,
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(withRouter(LogoutButton));